import Router from 'vue-router'
import Vue from 'vue'
Vue.use(Router)

export function safetyRedirect(pathname) {
  return () => {
    if (window.location.pathname.startsWith(vueRouter.options.base)) {
      return pathname
    }
    return false
  }
}

const vueRouter = new Router({
  mode: 'history',
  base: window.__POWERED_BY_QIANKUN__ ? '/datav-management' : process.env.VUE_APP_PATH,
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "page" */ '@/page/index'),
      redirect: safetyRedirect('/home'),
      children: [
        {
          path: 'home',
          component: () => import(/* webpackChunkName: "page" */ '@/page/list')
        },
        {
          path: 'category',
          component: () =>
            import(/* webpackChunkName: "page" */ '@/page/list/category')
        },
        {
          path: 'db',
          component: () =>
            import(/* webpackChunkName: "page" */ '@/page/list/db')
        },
        {
          path: 'map',
          component: () =>
            import(/* webpackChunkName: "page" */ '@/page/list/map')
        },
        {
          path: 'document',
          component: () =>
            import(/* webpackChunkName: "page" */ '@/page/list/document')
        },
        {
          path: 'glob',
          component: () =>
            import(/* webpackChunkName: "page" */ '@/page/list/glob')
        },
        {
          path: 'components',
          component: () =>
            import(/* webpackChunkName: "page" */ '@/page/list/components')
        },
        {
          path: 'record',
          component: () =>
            import(/* webpackChunkName: "page" */ '@/page/list/record')
        }
      ]
    },
    {
      path: '/create',
      name: 'create',
      component: () => import(/* webpackChunkName: "page" */ '@/page/create')
    },
    {
      path: '/build',
      name: 'build',
      component: () => import(/* webpackChunkName: "page" */ '@/page/build')
    },
    {
      path: '/build/:id',
      name: 'build',
      component: () => import(/* webpackChunkName: "page" */ '@/page/build')
    },
    {
      path: '/view/:id',
      name: 'view',
      component: () => import(/* webpackChunkName: "page" */ '@/page/view')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "page" */ '@/page/login')
    }
  ]
})
export default vueRouter
